import {create} from "zustand";
import axios from "axios";
import {api} from "./api";

export const useHouseStore = create((set, get) => ({
    house: null,
    loading: false,
    error: null,

    create: async (houseData, token) => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.post(
                `${api}/realty/create`,
                houseData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            set({loading: false});
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
            throw e;
        }

    },
    upload: async (id, files, token) => {
        set({loading: true, error: null});
        try {
            const formData = new FormData();
            files.forEach(file => formData.append("files", file));

            const {data} = await axios.post(
                `${api}/realty/upload-images/${id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            set({loading: false});
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
        }
    },
    uploadOne: async (id, file, token) => {
        set({loading: true, error: null});
        try {
            const formData = new FormData();
            formData.append("file", file);

            const {data} = await axios.post(
                `${api}/realty/upload-image/${id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            set({loading: false});
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
        }
    },
    deleteOne: async (realtyMediaId, token) => {
        set({loading: true, error: null});
        try {
            await axios.delete(
                `${api}/realty/delete/${realtyMediaId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            set({loading: false});
            return true;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка при удалении",
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
            return false;
        }
    },
    getHouseById: async (id, token) => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/realty/get-by-id/${id}`,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            set({house: data, loading: false});
            return data;
        } catch (e) {
            set({error: e.response?.data || "Ошибка", loading: false});
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
            return null;
        }
    },
    deleteMyHouse: async (id, token) => {
        set({loading: true, error: null});
        try {
            await axios.delete(`${api}/realty/delete-realty/${id}`, {
                headers: {Authorization: `Bearer ${token}`},
            });

            set({loading: false});
            return true;
        } catch (e) {
            const status = e.response?.status;
            if (status === 401) {
                localStorage.clear();
                window.location.href = "/login";
                return;
            }
            set({error: e.response?.data || "Ошибка", loading: false});
            console.error("Ошибка удаления:", e);
            return false;
        }
    },
    updateHouse: async (id, token, payload) => {
        set({loading: true, error: null});
        try {
            const {price_som, ...body} = payload;

            const {data} = await axios.patch(
                `${api}/realty/update/${id}`,
                body,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            set({house: data, loading: false});
            return data;
        } catch (e) {
            set({error: e.response?.data || "message", loading: false});
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
            return null;
        }
    },
    change: async ({old_password, new_password}) => {
        set({loading: true, error: null});
        try {
            const token = localStorage.getItem("access_token");
            if (!token) throw new Error("Токен не найден");

            await axios.patch(
                `${api}/realty/change_password`,
                {old_password, new_password},
                {headers: {Authorization: `Bearer ${token}`}}
            );

            set({loading: false});
            return true;
        } catch (e) {
            set({
                error:
                    e.response?.data?.detail ||
                    e.message ||
                    "Ошибка изменения пароля",
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
            return false;
        }
    },
}));
export const useChange = () => useHouseStore((state) => state.change);
export const useCreate = () => useHouseStore((state) => state.create);
export const useUpload = () => useHouseStore((state) => state.upload);
export const useUploadOne = () => useHouseStore((state) => state.uploadOne);
export const useDeleteOne = () => useHouseStore((state) => state.deleteOne);
export const useDeleteMyHouse = () => useHouseStore((state) => state.deleteMyHouse);
export const useGetHouse = () => useHouseStore((state) => state.getHouseById);
export const useUpdateHouse = () => useHouseStore((state) => state.updateHouse);
export const useHouse = () => useHouseStore((state) => state.house);
export const useLoading = () => useHouseStore((state) => state.loading);
